import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import defaultStyles from './separator.styles';

function Separator({ separator, separatorBorder }) {
  return (
    <View style={separator}>
      <View style={separatorBorder} />
    </View>
  );
}

Separator.propTypes = {
  separator: PropTypes.number,
  separatorBorder: PropTypes.number,
};

Separator.defaultProps = {
  separator: defaultStyles.separator,
  separatorBorder: defaultStyles.separatorBorder,
};

export default Separator;
